import React, { useEffect, useState } from 'react';
import { Input } from '@/components/ui/input';
import { searchSongs } from '../setlist/setlistApi';

/** Searches the existing Worship song library (same endpoint as the setlist editor) to link a historical line. */
const SongLinkPicker = ({ initialQuery = '', onPick, onCancel }) => {
  const [query, setQuery] = useState(initialQuery);
  const [results, setResults] = useState([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    const timer = setTimeout(() => {
      searchSongs(query, { limit: 8, signal: controller.signal })
        .then((page) => { setResults(page.items); setFailed(false); })
        .catch((error) => { if (error?.code !== 'ERR_CANCELED') setFailed(true); });
    }, 250);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [query]);

  return (
    <div className="mt-2 space-y-2 rounded-md border border-slate-200 bg-slate-50 p-3">
      <Input aria-label="Zoek lied in de bibliotheek" placeholder="Zoek lied in de bibliotheek" value={query} onChange={(event) => setQuery(event.target.value)} autoFocus />
      {failed && <p className="text-sm text-red-600">Zoeken mislukt</p>}
      <ul className="space-y-1">
        {results.map((song) => (
          <li key={song.id}>
            <button type="button" onClick={() => onPick(song)} aria-label={`Koppel aan ${song.title}`}
              className="flex min-h-11 w-full items-center justify-between gap-2 rounded-md border border-slate-200 bg-white px-3 text-left text-sm hover:border-teal-300">
              <span className="min-w-0 truncate font-medium">{song.title}</span>
              {song.artist && <span className="shrink-0 text-xs text-slate-500">{song.artist}</span>}
            </button>
          </li>
        ))}
        {!results.length && !failed && <li className="text-sm text-slate-500">Geen liederen gevonden</li>}
      </ul>
      <button type="button" onClick={onCancel} className="min-h-11 text-sm font-medium text-slate-600 underline">Annuleren</button>
    </div>
  );
};

export default SongLinkPicker;
